import React from 'react';
import { Helmet } from 'react-helmet';
import './style.css';

const Maintenance: React.FC = () => {
    return (
        <div className="maintenance flex flex-col items-center justify-center bg-gray-100">
            <Helmet>
                <title>goo.pet - Programeaza-ti animalul la Veterinar, Grooming, Pet Sitting si altele, creeaza-i profil, administreaza-i carnetul de sanatate</title>
            </Helmet>
            <div className="overlay"></div>
            <div className="container">
                <img className="max-w-[400px]" src='/assets/logo.svg' />
                <p>
                    Programeaza-ti animalul la Veterinar, Spalat si altele, creeaza-i profil, administreaza-i carnetul de sanatate</p>
                <h2>Coming soon!</h2>
                <div className="social-links">
                </div>
            </div>
        </div>
    );
};

export default Maintenance;